import { TCommonIconProps } from '@fe-toolkit/web-components/ssr'

export function Gear({ title, ...rest }: Omit<TCommonIconProps, 'sx'>) {
  return (
    <svg
      fill="none"
      height={rest.height ?? '19px'}
      viewBox="0 0 18 19"
      width={rest.width ?? '18px'}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {title && <title>{title}</title>}
      <path
        d="M17.9 8.1c.1.7.1 1.4 0 2-.1.6-.6 1-1.2 1h-.1c-.5 0-.9.3-1.1.7-.2.5-.1 1 .3 1.4.4.4.5 1 .1 1.5s-.9 1-1.4 1.4c-.5.3-1.1.3-1.5-.1-.3-.4-.9-.5-1.4-.3-.5.2-.8.7-.7 1.2 0 .6-.4 1.1-1 1.1-.3 0-.7.1-1 .1-.3 0-.7 0-1-.1-.6-.1-1-.6-1-1.1 0-.5-.3-1-.7-1.2-.4-.2-1 0-1.4.3-.4.4-1 .5-1.5.1s-1-.9-1.4-1.4c-.4-.4-.3-1.1.1-1.5.4-.3.5-.9.3-1.4-.1-.5-.5-.8-1-.8S.2 10.6.1 10C0 9.3 0 8.6.1 8c.1-.6.5-1 1.1-1 .5 0 1-.3 1.2-.7.2-.5.1-1-.3-1.4-.4-.3-.4-1-.1-1.4.4-.5.9-1 1.4-1.4.4-.3 1.1-.3 1.5.1.3.3.9.5 1.4.3.5-.2.8-.7.7-1.2C7 .7 7.4.2 8 .2c.7-.1 1.3-.1 2 0 .6.1 1 .6 1 1.1 0 .5.3 1 .7 1.2.4.2 1 0 1.4-.3.4-.4 1-.5 1.5-.1s1 .9 1.4 1.4c.3.5.3 1.1-.1 1.5-.4.3-.5.9-.3 1.3.2.5.6.7 1.1.7.5.1 1.1.5 1.2 1.1Zm-1.3 1.7V8.4c-1 0-1.8-.6-2.2-1.5-.4-.9-.2-1.9.5-2.6-.3-.4-.6-.7-1-1-.7.7-1.8.9-2.7.5-.9-.4-1.5-1.3-1.5-2.3H8.3c0 1-.6 1.8-1.5 2.2-.9.3-2 .1-2.7-.6-.4.3-.7.6-1 1 .7.7.9 1.8.5 2.7-.4.9-1.2 1.5-2.3 1.5v1.4c.9 0 1.8.6 2.2 1.5.4.9.2 1.9-.5 2.6.3.4.6.7 1 1 .7-.7 1.8-.9 2.7-.5.9.4 1.5 1.3 1.5 2.3h1.4c0-1 .6-1.8 1.5-2.2.9-.4 2-.1 2.6.5.4-.3.7-.6 1-1-.7-.7-.9-1.8-.5-2.7.5-.8 1.4-1.4 2.4-1.4Z"
        fill="#000"
      />
      <path
        d="M9 5.6c1.9 0 3.5 1.6 3.5 3.5s-1.6 3.5-3.5 3.5S5.5 11 5.5 9.1 7.1 5.6 9 5.6Zm0 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Z"
        fill="#000"
      />
    </svg>
  )
}
